import { Modal } from "react-bootstrap";
// import { handleFeedPrivacyAPICall } from '../../env/APImanager';

import "./FeedImageModal.css";
import { isValidImageUrl } from "../utils";

const FeedImageModal = (props) => {
  // Don't render modal if image is invalid
  if (!isValidImageUrl(props.image)) {
    return null;
  }

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="feed-image-modal-container"
      animation={true}
    >
      <div className="feed-image-modal-buttons-container">
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <img src={props.image} alt="Feed" className="feed-full-image" />
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default FeedImageModal;
